import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, input, model, output } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { DocumentiService } from 'src/app/core/documenti.service';
import { Acquisizione } from 'src/app/shared/models/acquisizione.model';

@Component({
  selector: 'app-temporary-send-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  <p-dialog header="Acquisizione ex art. 42 comma 8 124/2007" [(visible)]="visible" [modal]="true" (onHide)="hideDialog()">
    <label for="dal" class="small-label">Dal</label>
    <p-calendar [showIcon]="true" dateFormat="dd/mm/yy" [selectOtherMonths]="true" appendTo="body" [(ngModel)]="date"
    [inputStyle]="{'width': '187px'}">
    </p-calendar>
    <label for="note" class="small-label">Note</label>
    <textarea pInputTextarea id="note" [rows]="5" [cols]="30" [(ngModel)]="note"></textarea>
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      <button pButton type="button" class="p-button-primary" icon="fas fa-fw fa-file-export" label="Trasferisci" (click)="send_click()"
      [disabled]="!date || !note"></button>
    </p-footer>
  </p-dialog>
  `,
  styles: [`
  label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
  label:first-of-type { margin-top: 0; }
  `]
})

export class TemporarySendDialogComponent {
  visible = model.required<boolean>();
  documentId = input.required<number>();

  hide = output();
  done = output<Acquisizione>();
  fail = output<HttpErrorResponse>();

  public date: Date | null = null;
  public note = '';

  private confirmationService = inject(ConfirmationService);
  private documentiService = inject(DocumentiService);

  hideDialog(): void {
    this.date = null;
    this.note = '';
    this.hide.emit();
  }

  send_click(): void {
    if (!this.documentId() || this.documentId() < 0 || !this.date) return;

    const request: Acquisizione = {
      date: this.date,
      note: this.note
    };

    this.confirmationService.confirm({
      header: 'Acquisizione ex art. 42 comma 8 124/2007',
      message: `Eseguire l'<strong>acquisizione</strong> del documento?
      <p>L'acquisizione impedirà ogni ulteriore modifica.</p>`,
      acceptLabel: 'Completa acquisizione',
      icon: 'fas fa-fw fa-file-export',
      accept: () => {
        this.documentiService.temporarySend(this.documentId(), request).subscribe({
          next: () => {
            this.done.emit(request);
            this.hideDialog();
          },
          error: (error: HttpErrorResponse) => {
            this.fail.emit(error);
          }
        });
      }
    });
  }
}
